

<template>
  <div class="searchpage">
    <header class="search_header">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        @click="goBack()"
        style="height: 32px; width: 32px; padding: 5px 5px 5px 0; margin-right: 5px;"
      >
        <g fill="#000" fill-rule="evenodd">
          <path
            d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
          />
          <path
            d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
          />
        </g>
      </svg>
      <div class="search_bar">
        <i
          class="material-icons srch_icon"
          @click="clearSearchText()"
        >clear</i>
        <input
          class="cstm_srchbar"
          type="text"
          id="myInput"
          v-on:keyup="searchProducts($event)"
          inputmode="search"
          :placeholder="$t('namasteWhatDoYouWant')"
          v-model="searchTerm"
          style="border-radius:20px"
        />
        <i
          class="material-icons"
          v-if="searchTerm.length > 2"
          @click="goToSearchResult(searchTerm, false)"
          style="position: absolute; right: 5px;background: rgb(0, 145, 255);color: #fff; left: auto;padding: 5px;border-radius: 50%;font-size: 1.15em;"
        >search</i>
        <i
            class="material-icons"
            @click="isAi()"
            style="position:absolute; right:10px; color:#999"
            v-else
          >mic</i>
      </div>
      <div class="action flx" style="margin-left: 10px;">
      <span class="cart-icon" @click="goToCart()">
      <span class="one-cart-size" v-if="cartSize > 0" style="background:#f93;color:#fff">{{cartSize}}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="26" viewBox="0 0 21 26">
            <g >
              <path
                  fill= "#f93"
                  d="M20.986 21.44L19.804 6.81c-.074-.943-.886-1.681-1.849-1.681H15.62v-.103C15.62 2.255 13.323 0 10.5 0S5.381 2.255 5.381 5.026v.103H3.045c-.963 0-1.775.738-1.848 1.679L.014 21.443c-.092 1.172.322 2.338 1.135 3.2C1.963 25.505 3.116 26 4.313 26h12.374c1.197 0 2.35-.495 3.164-1.357.813-.862 1.227-2.028 1.135-3.202zM6.932 5.027c0-1.932 1.6-3.503 3.568-3.503 1.967 0 3.568 1.571 3.568 3.503v.103H6.932v-.103zm11.78 18.582c-.528.56-1.247.87-2.025.87H4.313c-.778 0-1.497-.31-2.025-.87-.529-.56-.787-1.288-.728-2.047L2.743 6.926c.012-.154.145-.274.302-.274h2.336v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h7.136v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h2.336c.157 0 .29.12.302.276L19.44 21.56c.06.761-.199 1.49-.727 2.05z"
              />
            </g>
          </svg>
      </span>
    </div>
    </header>
    <section class="detail_content">
      <div class="search_key_section hide" :class="{'show': suggestions.length>0}">
        <!-- <h3 v-if="suggestions.length && salesProducts.length ===0">{{$t('hotKeywords')}}</h3> -->
        <ul class="search_menu">
          <li
            v-bind:class="{'last': suggestions.length==1}"
            v-for="(p,index) in suggestions"
            :key="index"            
          >
          <div v-if="p.nameSuggest" @click="goToSearchResult(p.nameSuggest, true)">
            <span v-if="p.nameSuggest.length" v-html="p.term"></span>
            <span class="serachHit">
              <i class="material-icons">call_made</i>
            </span>
          </div>
          <div v-else @click="goToSearchResult(p.term, true)">
            <span v-if="p.term.length" v-html="p.term" @click="goToSearchResult(p.term, true)"></span>            
          </div>
          </li>
        </ul>
      </div>
      <SearchCategoryFilterOption
        :dataValue="salesProducts"
        :filterOptionList="itemFacetFields"
        @closeAllCat="closeAllCat"
        @closeAllCatFromHeader="closeAllCatFromHeader"
        @getFilterList="getAppliedFilterList"
        :isFilterOption="isFilterOption"
        :class="{'hideClass' : !isDisplay}"
        @getFilterClear="getClearFilter"
        ref="form"
      />
      <div
        :class="{'hideClass' : isDisplay}"
        class="product_listing_detail"
      >
      <div class="filter_product_list" v-if="salesProducts.length>0">
        <div
          class="filter_card"
          v-for="(product,index) in salesProducts"
          :key="index"
           :class="{'new-item-card': isTileView === 'LIST_VIEW'}"
        >
        <img src="../assets/images/icons/verified-icon.png" alt="loader" class="mVerified-Icon" v-if="product.sellerLiteDTO.isApproved"/>
       <p class="home-delivery-text" v-if="product.sellerLiteDTO.sellerShopSettingDTO && product.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable && isTileView === 'GRID_VIEW'">FREE HOME DELIVERY</p>
          <div class="img_wrapper spinner_wrapper" v-lazyload v-if="product.displayImage" @click="goToProductDetail(product.sellerItemRelationshipId)">
            <ImageSpinner class="image_spinner" />
            <img :data-url="product.displayImage" alt />
          </div>
          <div class="product_detail">
            <p class="product-name">{{product.productName}}</p>
            <p class="bought rating" style="display:flex;" v-if="parseFloat(product.averageRating) > 0">
            <star-rating
              :read-only="true"
              :increment="0.01"
              :starSize="10"
              active-color="#138808"
              :rating="Number(product.averageRating)"
              :show-rating="false"
            ></star-rating>
            <span style="padding-left: 4px;"> ({{product.ratingNum}})</span>
          </p>
          <p class="bought rating" style="display:flex;" v-else-if="!product.averageRating && $store.state.isViewType === 'GRID_VIEW'">
          No ratings yet
          </p>
            <div class="my_price_section">
              <span class="my_price" v-if="product.sellingPrice">
              <span class="rupee-font">₹​</span>{{ product.sellingPrice }}
              <span class="sp-badge" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPriceWithoutDiscount) && $store.state.isViewType === 'LIST_VIEW'">Your Price</span>
              </span>
            <span class="selling_price" v-if="product.sellingPriceWithoutDiscount"
              ><span class="rupee-font">₹​</span>​{{ product.sellingPriceWithoutDiscount }}</span
            >
            <span class="selling_price" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPriceWithoutDiscount) && product.mrp"
              ><span class="rupee-font">₹​</span>​{{ product.mrp }}</span
            >
            </div>
            <label class="price-less-tag" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPrice)">{{$t('lessWithXPrice',{lessAmount:Math.round(parseFloat(product.mrp)-parseFloat(product.sellingPrice))})}} </label>
            
            <p class="bought" style="color:black"  @click="viewShop(product.sellerLiteDTO.shopId)">
            {{$t('shop')}} -
            <span style="color:green">{{product.sellerLiteDTO.storeName}}</span>
            <!-- {{$t('peopleHaveBrought')}} -->
          </p>
          <p class="home-delivery-text" v-if="product.sellerLiteDTO.sellerShopSettingDTO && product.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable && isTileView === 'GRID_VIEW'">FREE HOME DELIVERY</p>
          <p v-if="product.gmallProductId" @click="goToProductDetail(product.sellerItemRelationshipId)">
              <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
              <p v-else>
                <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
          </div>
          
        </div>
      </div>
      <infinite-loading
        @infinite="getSearchProducts"
        spinner="circles"
        class="visibilityHidden"
        :identifier="resetIdentifier"
      >
        <template slot="no-results" style="color: #fff;">रिकॉर्ड उपलब्ध नहीं है</template>
      </infinite-loading>
      <NoDataFound v-if="notfounrdPrdt" />
      </div>
      <div class="bottom_filter" v-if="itemFacetFields.length">
        <div class="item filter" @click="viewAllCat()" style="border-left: 1px solid rgba(0, 0, 0, 0.28);width: 100%;">          
          <svg xmlns="http://www.w3.org/2000/svg" width="14.346" height="14.346" viewBox="0 0 14.346 14.346">
            <path id="ic_filter" d="M13.673-17.5h-13A.673.673,0,0,0,.2-16.352L5.38-11.169V-5.4a.673.673,0,0,0,.287.551L7.908-3.276a.673.673,0,0,0,1.058-.551v-7.342l5.182-5.183A.673.673,0,0,0,13.673-17.5Z" transform="translate(0 17.5)" fill="#fff"/>
          </svg>
          <span class="filterCount">
            {{$t('filter')}}
            <strong v-if="appliedFilter && parseFloat(selectedFacetCount)">{{selectedFacetCount}}</strong>
          </span>
        </div>
      </div>
    </section>
    <div class="cntntLoad" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
    <div id="cart-snackbar" :class="{'show': notCorrectSuggestion}" style="width:50%">
      <div class="flx" style="font-size: 1em;width: fit-content; margin: 0 auto;">
        <p>कृपया कुछ और बोलें</p>
      </div>
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
  </div>
</template>

<script>
import "../assets/css/product-list.scss";
import "../assets/css/category-tab.scss";
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import ImageSpinner from "../components/Common/ImageSpinner";
import NoDataFound from "../components/Common/NoDataFound";
import VueCookie from "vue-cookie";
import InfiniteLoading from "vue-infinite-loading";
import CustomToaster from "@/components/Common/CustomToaster"
import { mapGetters } from "vuex";
import ListQuantity from "./ListQuantity"
import types from "../store/types";
import Vue from "vue";
import StarRating from "vue-star-rating";
import SearchCategoryFilterOption from "@/components/ProductListSection/SearchCategoryFilterOption";
Vue.use(InfiniteLoading);

export default {
  name: "SearchPage",
  components: {
    ImageSpinner,
    InfiniteLoading,
    NoDataFound,
    CustomToaster,
    ListQuantity,
    StarRating,
    SearchCategoryFilterOption
  },
  computed : {
    ...mapGetters(["cartSize","userInfo"])
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js PWA",
      salesProducts: [],
      itemFacetFields: [],
      pageIndex: 0,
      loading: false,
      notfounrdPrdt: false,
      searchTerm: "",
      suggestions: [],
      toasterData: {},
      isValidDetail: false,
      notCorrectSuggestion: false,
      resetIdentifier: +new Date(),
      isTileView: '',
      suggestValueBoolean: false,
      isFilterOption: false,
      isDisplay: false,
      filterMinPrice: null,
      filterMaxPrice: null,
      appliedFilter: false,
      filterArray: [],
      newSearchList: false,
      selectedFacetCount: null
    };
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    viewAllCat() {
      this.isDisplay = true;
    },
    closeAllCatFromHeader(){
      this.isDisplay = false
    },
    closeAllCat() {
      this.isDisplay = false;
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex
      });
      this.filterMaxPrice = 1000000;
      this.filterMinPrice = 0;
      this.salesProducts = [];
      this.resetIdentifier +=1;
    },
    getAppliedFilterList(value1,value2,filterObject) {
      this.filterMinPrice = value1
      this.filterMaxPrice = value2
      this.filterArray = filterObject
      this.appliedFilter = true;
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex
      });
      this.salesProducts = [];
      this.resetIdentifier +=1;
      this.isDisplay = false;
    },
    getClearFilter(data) {
      if (data) {
        this.appliedFilter = true;
      } else {
        this.appliedFilter = false;
      }
    },
    viewShop(sellID) {
       if(sellID && !this.$route.query.shopid){
      this.$store.commit("saveCategories", {
        categories: [],
        catId: 0,
        catIndex: 0
      });
      this.$store.commit(types.CATEGORY_PRODUCT, []);
      // mOST POPULAR
      this.$store.commit("saveData", {
        mostSellingItemList: [],
        mostSellingPageIndex: 0,
        type: "most_selling_item",
      });
      if (sellID != this.$route.query.shopid) {
        if (this.$route.query.source === "ADS_SERVER") {
          if(this.$route.query.campaignUnitIdentifier){
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier +
              '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier
          );
          }else{
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier
          );
          }
          
        } else {
          this.$router.push("/daily-needs?shopid=" + sellID);
        }
      } else {
        if (this.$route.query.source === "ADS_SERVER") {
         if(this.$route.query.campaignUnitIdentifier){
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier +
              '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier
          );
          }else{
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier
          );
          }
        } else {
          this.$router.push("/daily-needs?shopid=" + sellID);
        }
      }
      }
    },
    goToCart(){
      this.$router.push('/cart-check-out')
    },
    isAi() {
      // this.$emit("AiCheck", true);
      
      try {
        _textSpeech.nativeSpeechToTextDialog = (res) => {
          if (res) {
            if(res.length > 2){
              this.salesProducts = [];
              this.suggestions = []
              this.searchTerm = res;
              this.pageIndex = 0;
              this.notfounrdPrdt = false;
              this.resetIdentifier +=1;
              // this.getSearchProducts();
            }
            else{
              console.log('please enter proper value')
              this.notCorrectSuggestion = true;
              setTimeout(()=> {
                this.notCorrectSuggestion = !this.notCorrectSuggestion;        
              }, 3000);
            }
          }
        };
        JSBridgePlugin.nativeSpeechToTextDialog(
          false,
          "_textSpeech.nativeSpeechToTextDialog",
          this.$cookie.get('lang')
          );
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
    },
    goToProductDetail(productSrId) {
      if(this.$route.query.shopid){
        this.$router.push("/detail/" + productSrId + '?source=LOCAL91_SEARCH' + '&shopid=' + this.$route.query.shopid);
      }else{
        this.$router.push("/detail/" + productSrId + '?source=LOCAL91_SEARCH');
      }
      
    },
    getUpdatedCartCount(){
      this.$store.commit(types.UPDATE_CART_SIZE, Math.round(parseInt(this.cartSize) + 1));
    },
    goToSearchResult(prodName,value) {
      this.suggestions = [];
      this.filterArray = [];
      this.appliedFilter = false;
      this.$refs.form.setBlankFaceList()
      this.suggestValueBoolean = value;
      if(prodName.length > 2){
        this.salesProducts = [];
        this.searchTerm = prodName;
        this.pageIndex = 0;
        this.notfounrdPrdt = false;
        this.resetIdentifier +=1;
        // this.getSearchProducts();
      }
      
    },

    clearSearchText() {
      this.searchTerm = "";
      this.appliedFilter = false;
      this.salesProducts = [];
      this.itemFacetFields = []
      this.pageIndex = 0;
      this.notfounrdPrdt = false;
      this.getSuggestedTerm();
    },
    searchProducts(event) {
      if (
        event != null &&
        typeof event.keyCode != "undefined" &&
        event.keyCode == 13
      ) {
        this.searchInput = event.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,"");
        this.getSuggestedList(this.searchInput)
        this.salesProducts = []
        this.notfounrdPrdt = false;
      } else {
        this.searchInput = event.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,"");
        this.salesProducts = []
        this.getSuggestedList(this.searchInput)
        this.notfounrdPrdt = false;
      }
    },
    getSearchProducts($state) {      
      if (this.searchTerm && this.searchTerm.length > 0) {
        this.loading = true
        this.searchTerm = this.searchTerm.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,"");
            const obj ={
              query: this.searchTerm.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,""),
              pageIndex: this.pageIndex,
              searchFilter: {
                pincodes: [this.userInfo.pincode]            
              },
              suggest: this.suggestValueBoolean
            }
            if(this.appliedFilter && this.filterArray.length){
              obj.searchFilter.itemFacetFields = this.filterArray
            }
            if(this.filterMinPrice && this.filterMaxPrice){
              obj.searchFilter.minPrice= this.filterMinPrice,
              obj.searchFilter.maxPrice= this.filterMaxPrice
            }
            if(this.$route.query.shopid){
              obj.searchFilter.shopIds = [this.$route.query.shopid]
            }
            ApiCaller(constant.SEARCH_PRODUCT_URL, `search`, "post",obj)
            .then(data => {              
              console.log(this.pageIndex)
              if (data && data.data && data.data.productListingDTOs && data.data.productListingDTOs.length > 0) {
                this.itemFacetFields = data.data.itemFacetFields
                this.selectedFacetCount = data.data.selectedFacetCount
                this.salesProducts.push(...data.data.productListingDTOs);
                this.pageIndex +=1;
                this.notfounrdPrdt = false;
                this.loading = false;
                $state && $state.loaded();
              } else {
                this.loading = false;
                if (this.salesProducts.length == 0) {
                  this.notfounrdPrdt = true;
                }
                $state && $state.complete();
              }
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
            });
      }else{
        this.getSuggestedTerm()
        $state && $state.complete();
      }
    },
    getSuggestedTerm(){
      if(this.$route.query.shopid){
        ApiCaller(constant.SEARCH_PRODUCT_URL, `search-terms/${this.userInfo.pincode}/${0}?shopId=${this.$route.query.shopid}`, "get")
        .then((data) => {
          this.suggestions = data.data.termDocumentDatas;
          }).catch(err =>{
        })
      }else{
        ApiCaller(constant.SEARCH_PRODUCT_URL, `search-terms/${this.userInfo.pincode}/${0}`, "get")
        .then((data) => {
          this.suggestions = data.data.termDocumentDatas;
          }).catch(err =>{
        })
      }
      
    },
    getSuggestedList(listTerm){
      if(listTerm.length >= 2){
      if(this.$route.query.shopid){
      ApiCaller(constant.SEARCH_PRODUCT_URL, `search-suggestions/${listTerm}/${this.userInfo.pincode}/${0}?highlight=true&shopId=${this.$route.query.shopid}`, "get")
        .then((data) => {
          if(data && data.data.termDocumentDatas.length){
            this.suggestions = data.data.termDocumentDatas;
          }else{
            this.suggestions = []
          }
          
          }).catch(err =>{
        })
      }else{
        ApiCaller(constant.SEARCH_PRODUCT_URL, `search-suggestions/${listTerm}/${this.userInfo.pincode}/${0}?highlight=true`, "get")
        .then((data) => {
          if(data && data.data.termDocumentDatas.length){
            this.suggestions = data.data.termDocumentDatas;
          }else{
            this.suggestions = []
          }
          
          }).catch(err =>{
        })
      }
    }
    }
  },
  mounted() {
    if(this.$store.state.isViewType){
      this.isTileView = this.$store.state.isViewType
    }
    this.searchTerm = this.$route.query.searchedItem;
  }
};
</script>
<style scoped>
.infinite-loading-container .infinite-status-prompt{
  color: #fff;
}
.visibilityHidden {
  visibility: hidden;
}
</style>